import { render, staticRenderFns } from "./warn_record_activity_detail.vue?vue&type=template&id=aca2632a"
import script from "./warn_record_activity_detail.vue?vue&type=script&lang=js"
export * from "./warn_record_activity_detail.vue?vue&type=script&lang=js"
import style0 from "./warn_record_activity_detail.vue?vue&type=style&index=0&id=aca2632a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports